export default __webpack_public_path__ + "images/8797db551fcdf70659385531c6cc68f8.svg";